export default __webpack_public_path__ + "static/media/greenFlower.fe8cb205.svg";